import CareerApp from './App/CareerApp.vue';
import { createApp } from 'vue';

const el = document.getElementById('career-app');
if (el) {
    createApp(CareerApp).mount(el);
}